import { render } from "./service-promise.vue?vue&type=template&id=c4a0437c&scoped=true"
import script from "./service-promise.vue?vue&type=script&lang=js"
export * from "./service-promise.vue?vue&type=script&lang=js"

import "./service-promise.vue?vue&type=style&index=0&id=c4a0437c&lang=scss&scoped=true"

import exportComponent from "/www/publicHouse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4a0437c"]])

export default __exports__